import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideLead,
  GuideCallout,
  GuideSectionLabel,
  GuideBlockList,
  GuideCard,
  GuideCardGrid,
} from "../GuideBlocks.js";

const EmotionalAwarenessExplainedSection = ({ heading, accentIndex = 1, getVisual, getAccent }) => (
  <GuidePanel
    sectionId="emotional-awareness-explained"
    heading={heading}
    accentIndex={accentIndex}
    getVisual={getVisual}
    getAccent={getAccent}
  >
    <GuideLead>
      Emotional awareness is the ability to recognize your emotions as they happen and understand how
      they influence your thoughts, decisions, and behavior.
    </GuideLead>
    <p className="guide-panel__p">Instead of saying, "I'm having a bad day," you learn to ask:</p>
    <GuideBlockList
      items={[
        "What am I actually feeling?",
        "Why am I feeling this way?",
        "What interpretation is attached to this emotion?",
      ]}
    />
    <p className="guide-panel__p">
      Emotional awareness is not about controlling every emotion. It is about becoming aware before
      reacting.
    </p>
    <GuideCallout>
      Think of emotions as dashboard indicators in a car. When the fuel light comes on, you don't
      break the dashboard. You understand that the car needs fuel. Similarly, emotions are signals.
      They tell us that something needs attention.
    </GuideCallout>
    <GuideSectionLabel>Why emotional awareness matters</GuideSectionLabel>
    <GuideCardGrid columns={2}>
      <GuideCard iconKey="clarity" title="Better decisions" />
      <GuideCard iconKey="communication" title="Healthier relationships" />
      <GuideCard iconKey="awareness" title="More deliberate conflict handling" />
      <GuideCard iconKey="growth" title="Faster return to clear thinking after setbacks" />
    </GuideCardGrid>
    <GuideCallout variant="amber">
      Awareness is the first step toward emotional intelligence. Without awareness, change is
      difficult.
    </GuideCallout>
  </GuidePanel>
);

export default EmotionalAwarenessExplainedSection;
